<template>
    <div class="login-warpper">
        <header-modular :url="'/login'" :back="'返回登录'"></header-modular>
        <div class="login-container">
            <div class="login-info">
                <div class="classifys">
                    <div class="classify">忘记密码</div>
                </div>
                <div class="login">
                    <el-form class="form" :model="forgetForm" :rules="forget_rules" ref="forgetForm">
                        <el-form-item prop="phone">
                            <div class="login-input">
                                <i class="iconfont icon-phone"></i>
                                <el-input v-model="forgetForm.phone" maxlength="11" placeholder="请输入手机号"
                                          class="login-item"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item prop="code">
                            <div class="login-input">
                                <i class="iconfont icon-password"></i>
                                <el-input v-model="forgetForm.code" maxlength="6" placeholder="请输入验证码"
                                          class="login-item"></el-input>
                                <div class="code-text" @click="submitSMS">
                                    {{codeText}} <span v-if="typeof codeText === 'number'">秒后重新发送</span>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="password">
                            <div class="login-input">
                                <i class="iconfont icon-password"></i>
                                <el-input v-model="forgetForm.password" placeholder="请输入密码" type="password"
                                          class="login-item"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item prop="repassword">
                            <div class="login-input">
                                <i class="iconfont icon-password"></i>
                                <el-input v-model="forgetForm.repassword" placeholder="请再次输入密码" type="password"
                                          class="login-item"></el-input>
                            </div>
                        </el-form-item>

                        <el-form-item>
                            <div class="login-button" @click="submitForm('forgetForm')">立即修改</div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
    </div>
</template>

<script>
    import rules from '@/utils/rules'
    import {sendForgetSms, forgetPassword} from "@/api/login";
    import FooterModular from "@/components/FooterModular.vue";
    import HeaderModular from "@/components/HeaderModular.vue";

    export default {
        name: "forget",
        data() {
            let validatePassSame = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认密码'));
                } else if (value !== this.forgetForm.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                forgetForm: {
                    phone: '',
                    password: '',
                    repassword: '',
                    code: '',
                },
                forget_rules: {
                    phone: rules.tel,
                    password: [
                        {required: true, message: '请输入密码', trigger: 'change'},
                        rules.password
                    ],
                    repassword: [
                        {validator: validatePassSame, trigger: 'change'},
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'change'}
                    ],
                },
                codeText: '获取验证码', // 验证码文字
                id: null, // 计时器id
                timeId: null, // 一次性计时器id
            }
        },
        created() {
        },
        components: {FooterModular, HeaderModular},
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.forget()
                    }
                });
            },
            async forget() {
                const loading = this.$loading({
                    lock: true,
                    text: '正在修改...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let _state = await forgetPassword(this.forgetForm.phone, this.forgetForm.code, this.forgetForm.password, this.forgetForm.repassword)
                loading.close();
                if (_state.status === 200) {
                    this.$message.success(_state.msg)
                    this.toBack()
                }
            },
            submitSMS() {
                this.$refs.forgetForm.validateField('phone', (valid) => {
                    if (!valid) {
                        this.sendCode()
                    }
                })
            },
            async sendCode() {
                if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在发送...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let _data = await sendForgetSms(this.forgetForm.phone,1)
                    loading.close();
                    if (_data.status === 200) {
                        let codeNum = 60
                        this.id = setInterval(() => {
                            if (codeNum === 0) {
                                this.codeText = '重新发送'
                                clearInterval(this.id)
                                return
                            }
                            if (typeof codeNum === 'number') {
                                codeNum--
                                this.codeText = codeNum
                            }
                        }, 1000)
                    } else {
                        this.codeText = '重新发送'
                        clearInterval(this.id)
                    }
                }
            },
            toBack() {
                this.$router.go(-1)
            }
        },
        filters: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    .login-warpper {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        min-height: 100vh;
        .login-container {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex: 1;
            width: 100%;
            background-size: cover;
            background: url(../assets/img/bg_login.png) no-repeat center;;
            background-size: 100%;
            .login-info {
                display: flex;
                flex-direction: column;
                width: 400px;
                background-color: #0a2240;
                border-radius: 10px;
                position: relative;
                padding: 45px;
                margin-right: 150px;
                z-index: 1;
                &:after {
                    position: absolute;
                    width: 561px;
                    height: 357px;
                    background: rgba(10, 34, 64, .1);
                    border-radius: 10px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    content: '';
                    z-index: -1;
                }
                &:before {
                    position: absolute;
                    width: 489px;
                    height: 450px;
                    margin: 0 auto;
                    background: rgba(10, 34, 64, .3);
                    border-radius: 10px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    content: '';
                    z-index: -1;
                }
                .form {
                    margin-top: 50px;
                    .login-input {
                        display: flex;
                        align-items: center;
                        height: 48px;
                        border-radius: 4px;
                        border: solid 1px #ffffff;
                        padding: 0 20px;
                        i {
                            display: block;
                            text-align: center;
                            font-size: 20px;
                            color: #ffffff;
                        }
                        .login-item {
                            flex: 1;
                            color: #ffffff;
                        }
                        .code-img {
                            width: 116px;
                            height: 43px;
                            background: #fff;
                        }
                        .code-text {
                            flex-shrink: 0;
                            text-align: center;
                            line-height: 41px;
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                }
                .login-button {
                    width: 100%;
                    height: 46px;
                    background-image: linear-gradient(168deg,
                            #ffb400 0%,
                            #fc7802 100%),
                    linear-gradient(
                                    #ff9600,
                                    #ff9600);
                    background-blend-mode: normal,
                    normal;
                    border-radius: 10px;
                    text-align: center;
                    font-size: 18px;
                    line-height: 46px;
                    color: #ffffff;
                    cursor: pointer;
                    user-select: none;
                }
                .classifys {
                    align-items: center;
                    margin-top: 15px;
                    position: relative;
                    &:before {
                        position: absolute;
                        width: 308px;
                        height: 1px;
                        background-color: #ffffff;
                        opacity: 0.4;
                        content: '';
                        bottom: -15px;
                        left: 0;
                    }
                    .classify {
                        flex: 1;
                        font-size: 18px;
                        text-align: center;
                        color: #ffffff;
                        position: relative;
                    }
                }
            }
        }

    }
</style>